import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Button, Grid, Stack, TextField, Typography, useTheme, useMediaQuery } from '@mui/material';
import { ReactComponent as Logo } from '../logo.svg';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ 
      bgcolor: '#171C20', 
      color: 'white', 
      py: isMobile ? 4 : 6, 
      px: { xs: 2, sm: 4, md: 8 } 
    }} component="footer">
      <Grid 
        container 
        spacing={isMobile ? 3 : 4} 
        maxWidth="xl" 
        mx="auto"
        sx={{
          '& .MuiGrid-root': {
            mb: isMobile ? 2 : 0
          }
        }}
      >
        {/* Logo & Contact */}
        <Grid size={isSmallMobile ? 12 : isMobile ? 6 : 3}>
          <Stack spacing={isMobile ? 2 : 3}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Logo width={isMobile ? 80 : 100} />
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <LocationOnIcon color="primary" sx={{ fontSize: isMobile ? 18 : 24 }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                8819 Ohio St. South Gate, CA 90280
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <EmailIcon color="primary" sx={{ fontSize: isMobile ? 18 : 24 }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                Ourstudio@hello.com
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <PhoneIcon color="primary" sx={{ fontSize: isMobile ? 18 : 24 }} />
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                +1 386-688-3295
              </Typography>
            </Stack>
          </Stack>
        </Grid>
        {/* Service */}
        <Grid size={isSmallMobile ? 6 : isMobile ? 3 : 2}>
          <Typography 
            fontWeight="bold" 
            mb={isMobile ? 1 : 2}
            sx={{ 
              fontSize: isMobile ? '0.875rem' : '1rem'
            }}
          >
            Service
          </Typography>
          <Stack spacing={isMobile ? 0.5 : 1}>
            {['Illustration', 'Mobile Design', 'Motion Graphic', 'Web Design', 'Development', 'SEO'].map((item) => (
              <Typography 
                key={item}
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        </Grid>
        {/* Company */}
        <Grid size={isSmallMobile ? 6 : isMobile ? 3 : 2}>
          <Typography 
            fontWeight="bold" 
            mb={isMobile ? 1 : 2}
            sx={{ 
              fontSize: isMobile ? '0.875rem' : '1rem'
            }}
          >
            Company
          </Typography>
          <Stack spacing={isMobile ? 0.5 : 1}>
            {['Service', 'Features', 'Our Team', 'Portfolio', 'Blog', 'Contact Us'].map((item) => (
              <Typography 
                key={item}
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        </Grid>
        {/* Social Media */}
        <Grid size={isSmallMobile ? 6 : isMobile ? 3 : 2}>
          <Typography 
            fontWeight="bold" 
            mb={isMobile ? 1 : 2}
            sx={{ 
              fontSize: isMobile ? '0.875rem' : '1rem'
            }}
          >
            Our Social Media
          </Typography>
          <Stack spacing={isMobile ? 0.5 : 1}>
            {['Dribbble', 'Behance', 'Medium', 'Instagram', 'Facebook', 'Twitter'].map((item) => (
              <Typography 
                key={item}
                variant="body2" 
                sx={{ 
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  lineHeight: 1.4
                }}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        </Grid>
        {/* Newsletter */}
        <Grid size={isSmallMobile ? 12 : isMobile ? 6 : 3}>
          <Typography 
            color="primary" 
            fontWeight="bold" 
            mb={isMobile ? 1 : 1}
            sx={{ 
              fontSize: isMobile ? '0.875rem' : '1rem'
            }}
          >
            Join a Newsletter
          </Typography>
          <Typography 
            mb={isMobile ? 0.5 : 1}
            sx={{ 
              fontSize: isMobile ? '0.75rem' : '0.875rem'
            }}
          >
            Your Email
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter Your Email"
            variant="outlined"
            size={isMobile ? "small" : "medium"}
            sx={{ 
              bgcolor: '#23282D', 
              borderRadius: 1, 
              mb: isMobile ? 1 : 2, 
              input: { 
                color: 'white',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                padding: isMobile ? '8px 12px' : '12px 14px'
              } 
            }}
            InputProps={{
              style: { color: 'white' },
            }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            fullWidth 
            sx={{ 
              borderRadius: 1, 
              textTransform: 'none',
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              padding: isMobile ? '8px 16px' : '10px 20px'
            }}
          >
            Send
          </Button>
        </Grid>
      </Grid>
      <Box mt={isMobile ? 4 : 6} textAlign="center">
        <Typography 
          variant="body2" 
          color="gray"
          sx={{ 
            fontSize: isMobile ? '0.75rem' : '0.875rem'
          }}
        >
          Copyright @bellhop-express 2025
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer; 